/**
 * 解析图片URL对象
 * @param {string|object} imageData - 图片数据
 * @param {object} options - 配置选项
 * @returns {string} 解析后的URL
 */
export const parseImageUrl = (imageData, options = {}) => {
  try {
    // 如果输入为空，直接返回空字符串
    if (!imageData) return '';

    // 基础解析逻辑
    const parsed = typeof imageData === 'string' ? JSON.parse(imageData) : imageData;
    
    if (Array.isArray(parsed) && parsed.length > 0) {
      const { ServerUrl, FilePath } = parsed[0];
      return ServerUrl ? `${ServerUrl}${FilePath}` : FilePath;
    }
    
    if (parsed && typeof parsed === 'object') {
      const { ServerUrl, FilePath } = parsed;
      return ServerUrl ? `${ServerUrl}${FilePath}` : FilePath;
    }
    
    return '';
  } catch (error) {
    console.error('解析图片URL失败:', error);
    return '';
  }
}; 